 <template>
    <el-select
        @change="SelectChange"
        v-model="selectValue"
        size="mini"
        :style="{ width: width, margin: margin }"
        placeholder="请选择票据类型"
        clearable
        filterable>
        <el-option v-for="(item, idx) in select" :key="idx" :label="item.name"  :value="item.id" :disabled="itemDisabled && !item.state">
            <span style="float: left;">{{ item.name }}</span>
            <span style="float: right; color: #8492a6; font-size: 12px">税率：{{ item.taxation_rate }}</span>
        </el-option>
    </el-select>
</template>
<script>
export default {
    props: {
        value: {
            type: [String, Array, Number],
            default: null
        },
        itemDisabled: {
            type: Boolean,
            default: false
        },
        width: {
            type: String,
            default: '100%'
        },
        margin: {
            type: String,
            default: '0px'
        },
    },
    watch: {
        value () {
            this.selectValue = this.value
        }
    },
    data () {
        return {
            select: [],
            selectValue: null,
        }
    },
    mounted () {
        this.$http.post('/9api/config-invoice-type/search-all').then(rps => {
            this.select = rps.data
        })
    },
    methods: {
        SelectChange(id) {
            this.$emit('input', id)
            this.$emit('onChange', this.select.filter(item => item.id == id)[0])
        }
    }
}
</script>